import { Paper, Box } from "@mui/material"
import { makeStyles } from "makeStyles"
import Icon from "@mdi/react"
import { mdiBook, mdiShieldAccount, mdiNotebook } from "@mdi/js"

import Link from "components/i18n/Link"
import useTranslationCustom from "hooks/useTranslation"

const useStyles = makeStyles()((theme) => ({
	paper: {
		padding: theme.spacing(2),
		paddingRight: theme.spacing(1),
		color: "#274041",
		boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.15)",
		marginBottom: "20px",
	},
}))

const WebSiteInfoNav = () => {
	const { classes } = useStyles()
	const { t } = useTranslationCustom("legal")

	return (
		<Box mb={5}>
			<Link href="/imprint">
				<Paper className={classes.paper}>
					<div style={{ display: "flex" }}>
						<div style={{ marginRight: "10px" }}>
							<Icon path={mdiBook} size={1.3} color="#7ABFAC" />
						</div>
						<div>
							<strong>{t("imprint")}</strong> <br />
							{t("imprintText")}
						</div>
					</div>
				</Paper>
			</Link>
			<Link href="/privacy-policy">
				<Paper className={classes.paper}>
					<div style={{ display: "flex" }}>
						<div style={{ marginRight: "15px" }}>
							<Icon path={mdiShieldAccount} size={1.3} color="#FFD462" />
						</div>
						<div>
							<strong>{t("privacyPolicy")}</strong> <br />
							{t("privacyPolicyText")}
						</div>
					</div>
				</Paper>
			</Link>
			<Link href="/terms-and-conditions">
				<Paper className={classes.paper}>
					<div style={{ display: "flex" }}>
						<div style={{ marginRight: "15px" }}>
							<Icon path={mdiNotebook} size={1.3} color="#1B5C71" />
						</div>
						<div>
							<strong>{t("gtc")}</strong> <br />
							{t("gtcText")}
						</div>
					</div>
				</Paper>
			</Link>
		</Box>
	)
}

export default WebSiteInfoNav
